seedWebApp.controller('PricesTabController', ['$scope', '$uibModal', 'PricesService', 'TranslationService', function ($scope, $uibModal, PricesService, TranslationService) {

    $scope.translation = TranslationService.getActiveTranslation();

    //customClass: function () { return 'agp-color'; }

    $scope.storageClass = function () {
        return 'sd-storage';
    };

    $scope.columns = [
        { name: 'MaterialName', id: 'MaterialID', display: $scope.translation.MaterialID, filterOptions: [], width: 20, isKey: true },
        { name: 'StorageID', display: $scope.translation.StorageID, filterOptions: [], width: 5, customClass: $scope.storageClass },
        { name: 'PriceValue', display: 'Preço Médio', currencyFormat: 'R$', dataType: 'number', filterOptions: [], width: 5 },
        { name: 'PricePerc', display: 'Perc (%)', dataType: 'number', filterOptions: [], width: 5, customClass: $scope.qtStockClass },
        { name: 'PriceFinal', display: 'Preço Final', dataType: 'currency', filterOptions: [], width: 5, customClass: $scope.qtStockClass },
        { name: 'PriceCurrency', display: 'Moeda', filterOptions: [], width: 5 },
        { name: 'UpdateDate', display: $scope.translation.UpdateDate, dataType: 'date', format: 'dd/MM/yyyy HH:mm:ss', filterOptions: [], width: 5 },
    ];

    $scope.prefs = {
        name: 'PricesGrid',
        selContact: null,
        sortByCol: null,
        canAdd: false,
        canEdit: true,
        canDelete: false
    };

    $scope.loadColumns = PricesService.getPricesColumns;
    $scope.loadService = PricesService.getPrices;
    $scope.resetService = PricesService.resetCache;

    $scope.loadTotal = function () {
        $scope.loadingTotal = true;
        PricesService.getPricesCount().then(function (response) {
            $scope.loadingTotal = false;
            $scope.totalItems = response.data;
        });
    };

    $scope.loadTotal();

    $scope.searchMode = function () {
        $scope.$broadcast('inputSearch', $scope.filterString);
    };

    $scope.doRefresh = function () {
        $scope.$broadcast('refreshServiceGrid');
    };

    $scope.toExcel = function () {
        $scope.$broadcast('toExcel', 'Precos_Midea');
    };

    $scope.prefs.customEdit = function (item) {

        var modalInstance = $uibModal.open({
            templateUrl: './SPA/Prices/pricesModal.html',
            controller: 'PricesModalCtrl',
            size: 'md',
            resolve: {
                materialID: function () {
                    return item.MaterialID;
                }
            }
        });

        modalInstance.result.then(function () {
            $scope.doRefresh();
        });
    };

}]);